import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Models } from '../../skill-architecture/models/skill-architecture-form';

@Injectable({ providedIn: 'root' })
export class SelectedModelService {
    private messageSubject = new BehaviorSubject<Models | undefined>(undefined);

    // Method to send data
    sendMessage(selectedModel: Models | undefined) {
        if (selectedModel) {
            this.messageSubject.next(selectedModel);
        }
    }

    // Method to receive data
    getMessage(): Observable<Models | undefined> {
        return this.messageSubject.asObservable();
    }
}
